import { HTMLProps } from "react";

export function LangIcon(props: HTMLProps<any>) {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			{...props}
		>
			<path
				d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 6H12M6 9H12M6 12H12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function CloseIcon(props: HTMLProps<any>) {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			{...props}
			style={{ outline: "none" }}
		>
			<g clipPath="url(#clip0_99_8291)">
				<path
					d="M10.3662 8.81849L17.5481 1.63665C17.9111 1.27361 17.9111 0.677654 17.5481 0.314613L17.5087 0.275291C17.1457 -0.0877324 16.5498 -0.0877324 16.1867 0.275291L9.00489 7.46622L1.82304 0.272268C1.46002 -0.0907559 0.864051 -0.0907559 0.501027 0.272268L0.461688 0.31159C0.0895937 0.674613 0.0895937 1.27058 0.461688 1.63361L7.64355 8.81849L0.461688 16.0003C0.098664 16.3633 0.098664 16.9593 0.461688 17.3223L0.501027 17.3617C0.864051 17.7247 1.46002 17.7247 1.82304 17.3617L9.00489 10.1798L16.1867 17.3617C16.5498 17.7247 17.1457 17.7247 17.5088 17.3617L17.5481 17.3223C17.9111 16.9593 17.9111 16.3633 17.5481 16.0003L10.3662 8.81849Z"
					fill="#353535"
					className="!fill-t1"
				/>
			</g>
			<defs>
				<clipPath id="clip0_99_8291">
					<rect width="18" height="18" fill="white" className="!fill-t1" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function UserIcon(props: HTMLProps<any>) {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			{...props}
		>
			<g clipPath="url(#clip0_93_8753)">
				<path
					d="M12 13.334C12 12.2731 11.5786 11.2557 10.8284 10.5056C10.0783 9.75541 9.06087 9.33398 8 9.33398C6.93913 9.33398 5.92172 9.75541 5.17157 10.5056C4.42143 11.2557 4 12.2731 4 13.334"
					stroke="#353535"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M7.99992 9.33333C9.47268 9.33333 10.6666 8.13943 10.6666 6.66667C10.6666 5.19391 9.47268 4 7.99992 4C6.52716 4 5.33325 5.19391 5.33325 6.66667C5.33325 8.13943 6.52716 9.33333 7.99992 9.33333Z"
					stroke="#353535"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M7.99992 14.6673C11.6818 14.6673 14.6666 11.6825 14.6666 8.00065C14.6666 4.31875 11.6818 1.33398 7.99992 1.33398C4.31802 1.33398 1.33325 4.31875 1.33325 8.00065C1.33325 11.6825 4.31802 14.6673 7.99992 14.6673Z"
					stroke="#353535"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_93_8753">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function DepositIcon(props: HTMLProps<any>) {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			{...props}
		>
			<path
				d="M13.3333 1.33398L10.3333 4.33398"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.3334 5.26562V14.0003C13.3334 14.1771 13.2632 14.3467 13.1382 14.4717C13.0131 14.5967 12.8436 14.667 12.6667 14.667H4.33341C3.89139 14.667 3.46746 14.4914 3.1549 14.1788C2.84234 13.8662 2.66675 13.4423 2.66675 13.0003C2.66675 12.5583 2.84234 12.1343 3.1549 11.8218C3.46746 11.5092 3.89139 11.3336 4.33341 11.3336H13.3334"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.66675 13.0007V3.00065C2.66675 2.55862 2.84234 2.1347 3.1549 1.82214C3.46746 1.50958 3.89139 1.33398 4.33341 1.33398H9.56275"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.33333 6.66667C10.0697 6.66667 10.6667 6.06971 10.6667 5.33333C10.6667 4.59695 10.0697 4 9.33333 4C8.59695 4 8 4.59695 8 5.33333C8 6.06971 8.59695 6.66667 9.33333 6.66667Z"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
export function GemIcon(props: HTMLProps<any>) {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			{...props}
		>
			<path
				d="M13.3334 10V14C13.3334 14.1768 13.2632 14.3464 13.1382 14.4714C13.0131 14.5964 12.8436 14.6667 12.6667 14.6667H4.33341C3.89139 14.6667 3.46746 14.4911 3.1549 14.1785C2.84234 13.866 2.66675 13.442 2.66675 13C2.66675 12.558 2.84234 12.134 3.1549 11.8215C3.46746 11.5089 3.89139 11.3333 4.33341 11.3333H13.3334"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.66675 13.0007V3.00065C2.66675 2.55862 2.84234 2.1347 3.1549 1.82214C3.46746 1.50958 3.89139 1.33398 4.33341 1.33398H6.66675"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.125 3H8.875C8.39175 3 8 3.40888 8 3.91326C8 3.91326 11.2812 8 11.6348 8C11.9883 8 15 3.91326 15 3.91326C15 3.40888 14.6082 3 14.125 3Z"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M11.5 8V3" stroke="#5E5E5E" />
		</svg>
	);
}
export function CreationIcon(props: HTMLProps<any>) {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			{...props}
		>
			<g clipPath="url(#clip0_93_8791)">
				<path
					d="M6.62455 10.3342C6.56503 10.1034 6.44477 9.89289 6.27629 9.72441C6.10781 9.55592 5.89726 9.43567 5.66655 9.37615L1.57655 8.32148C1.50677 8.30168 1.44535 8.25965 1.40162 8.20178C1.35789 8.14391 1.33423 8.07335 1.33423 8.00082C1.33423 7.92828 1.35789 7.85772 1.40162 7.79985C1.44535 7.74198 1.50677 7.69996 1.57655 7.68015L5.66655 6.62482C5.89718 6.56535 6.10767 6.4452 6.27615 6.27684C6.44462 6.10849 6.56492 5.89808 6.62455 5.66748L7.67921 1.57748C7.69882 1.50743 7.7408 1.44571 7.79876 1.40175C7.85672 1.35778 7.92747 1.33398 8.00021 1.33398C8.07296 1.33398 8.14371 1.35778 8.20166 1.40175C8.25962 1.44571 8.30161 1.50743 8.32121 1.57748L9.37521 5.66748C9.43473 5.8982 9.55499 6.10875 9.72347 6.27723C9.89195 6.44571 10.1025 6.56597 10.3332 6.62548L14.4232 7.67948C14.4935 7.69888 14.5556 7.74082 14.5998 7.79887C14.644 7.85691 14.6679 7.92786 14.6679 8.00082C14.6679 8.07378 14.644 8.14472 14.5998 8.20277C14.5556 8.26081 14.4935 8.30275 14.4232 8.32215L10.3332 9.37615C10.1025 9.43567 9.89195 9.55592 9.72347 9.72441C9.55499 9.89289 9.43473 10.1034 9.37521 10.3342L8.32055 14.4242C8.30094 14.4942 8.25896 14.5559 8.201 14.5999C8.14304 14.6439 8.07229 14.6677 7.99955 14.6677C7.9268 14.6677 7.85605 14.6439 7.79809 14.5999C7.74013 14.5559 7.69815 14.4942 7.67855 14.4242L6.62455 10.3342Z"
					stroke="#5E5E5E"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_93_8791">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
export function CommentIcon(props: HTMLProps<any>) {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			{...props}
		>
			<path
				d="M14 10C14 10.3536 13.8595 10.6928 13.6095 10.9428C13.3594 11.1929 13.0203 11.3333 12.6667 11.3333H4.66667L2 14V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V10Z"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.66675 5.33398H4.66675"
				stroke="#5E5E5E"
				strokeWidth="0.666667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.3334 8H4.66675"
				stroke="#5E5E5E"
				strokeWidth="0.666667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
export function InviteIcon(props: HTMLProps<any>) {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			{...props}
		>
			<path
				d="M14.6666 8.66602V3.99935C14.6666 3.64573 14.5261 3.30659 14.2761 3.05654C14.026 2.80649 13.6869 2.66602 13.3333 2.66602H2.66659C2.31296 2.66602 1.97382 2.80649 1.72378 3.05654C1.47373 3.30659 1.33325 3.64573 1.33325 3.99935V11.9993C1.33325 12.7327 1.93325 13.3327 2.66659 13.3327H7.99992"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.6666 4.66602L8.68659 8.46602C8.48077 8.59497 8.2428 8.66336 7.99992 8.66336C7.75704 8.66336 7.51907 8.59497 7.31325 8.46602L1.33325 4.66602"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.6667 10.666V14.666"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.6667 12.666H14.6667"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
export function ContactIcon(props: HTMLProps<any>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			{...props}
		>
			<path
				d="M14.5 9.14564C14.5 8.09364 13.862 7.19214 12.9595 6.77914C12.8845 4.11114 10.705 1.93164 8 1.93164C5.2945 1.93164 3.1155 4.07314 3.0405 6.77864C2.1385 7.19214 1.5 8.09364 1.5 9.14564C1.50132 9.83281 1.77488 10.4915 2.26079 10.9774C2.74669 11.4633 3.40533 11.7368 4.0925 11.7381H4.1675C4.3555 11.7381 4.5435 11.5506 4.5435 11.3626V6.92914C4.5435 6.74114 4.3555 6.55364 4.1675 6.55364H3.8295C3.9795 4.41214 5.783 2.68364 8 2.68364C10.2175 2.68364 12.02 4.41214 12.2085 6.59114H11.832C11.6445 6.59114 11.457 6.77914 11.457 6.96664V11.2496C10.2545 12.5651 8.601 13.3166 6.835 13.3166C6.6095 13.3166 6.4595 13.4671 6.4595 13.6921C6.4595 13.9176 6.61 14.0676 6.835 14.0676C8.827 14.0676 10.705 13.2031 12.02 11.7381C13.41 11.6631 14.5 10.5361 14.5 9.14564ZM3.754 10.9486C3.33094 10.874 2.94797 10.652 2.67295 10.322C2.39793 9.99195 2.24863 9.57522 2.2515 9.14564C2.2515 8.24414 2.89 7.49264 3.792 7.34264V10.9491H3.754V10.9486ZM12.2085 10.9486V7.34214C13.073 7.49264 13.7485 8.24414 13.7485 9.14514C13.7485 10.0476 13.073 10.7991 12.2085 10.9486Z"
				fill="#5E5E5E"
			/>
		</svg>
	);
}
export function LogoutIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M10.6667 11.3346L14 8.0013L10.6667 4.66797"
				stroke="#C8C8C8"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 8H6"
				stroke="#C8C8C8"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6"
				stroke="#C8C8C8"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function EditIcon(props: HTMLProps<any>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			role="img"
			{...props}
		>
			<path
				d="M15.4399 14.9475C15.4399 15.8555 15.0959 16.5155 14.1799 16.5155H4.21595C3.29995 16.5155 2.83595 16.0955 2.83595 15.1875V4.81147C2.83595 3.90347 3.17995 3.60747 4.09595 3.60747H8.16395C8.52795 3.60747 8.82395 3.35147 8.82395 2.98347C8.82395 2.65947 8.55995 2.39547 8.23195 2.39547H3.65995C2.55195 2.39147 1.65195 3.28347 1.64795 4.38747V15.7315C1.65195 16.8395 2.55595 17.7315 3.65995 17.7275H14.6519C15.7599 17.7275 16.6639 16.8315 16.6639 15.7315V11.3675C16.6639 11.0115 16.3719 10.7235 16.0159 10.7315C15.6719 10.7395 15.4359 11.0195 15.4359 11.3635L15.4399 14.9475ZM17.4199 3.37947L16.2439 2.33147C15.9359 2.02347 15.5159 1.85547 15.0839 1.85547C14.6439 1.85547 14.2359 2.02347 13.9239 2.33147L7.26395 9.01147C7.01995 9.25547 6.27595 9.95547 6.26395 10.2955V10.3035L5.65995 13.6795C5.61995 13.8635 5.77995 14.0275 5.96395 13.9875L9.62795 13.3395C9.78795 13.3115 10.3759 12.6995 10.6839 12.3955L17.5439 5.59547C17.8519 5.28747 17.9439 4.95947 17.9439 4.52747C17.9399 4.09547 17.7279 3.68747 17.4199 3.37947ZM8.53195 12.5795L6.81595 12.9875C6.70395 13.0115 6.59995 12.9115 6.62795 12.7995L7.07595 11.1555C7.08395 11.1115 7.13995 11.0955 7.17195 11.1275L8.54795 12.4915C8.57195 12.5195 8.56395 12.5635 8.53195 12.5795ZM9.36395 12.0995C9.33995 12.1115 9.31195 12.1115 9.29195 12.0915L7.56395 10.3395C7.54395 10.3195 7.53995 10.2875 7.55995 10.2635C7.74395 10.0195 12.8639 4.90347 12.8639 4.90347C12.8879 4.87947 12.9239 4.87947 12.9439 4.90347L14.7799 6.72347C14.8039 6.74747 14.8039 6.78347 14.7799 6.80347C14.7839 6.80747 9.58395 11.9635 9.36395 12.0995ZM16.6679 5.05547L15.4879 6.23147C15.4679 6.25147 15.4319 6.25147 15.4079 6.23147L13.4879 4.37147C13.4639 4.34747 13.4639 4.31547 13.4879 4.29147L14.6719 3.11947C14.7959 2.99547 14.9639 2.92747 15.1399 2.92747C15.3159 2.92747 15.4839 2.99547 15.6079 3.11947L16.6719 4.13547C16.7959 4.25947 16.8639 4.42347 16.8639 4.59947C16.8639 4.76747 16.7919 4.93547 16.6679 5.05547Z"
				fill="#5E5E5E"
			/>
		</svg>
	);
}

export function CheckIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="17"
			height="13"
			viewBox="0 0 17 13"
			fill="none"
		>
			<path
				d="M16.7591 0.220309C16.612 0.0762912 16.4144 -0.00292037 16.2095 8.23583e-05C16.0046 0.00308509 15.8093 0.0880565 15.6665 0.236322L6.13505 10.1418L1.31832 5.13815C1.17465 4.99379 0.980546 4.91217 0.77782 4.91088C0.575094 4.90959 0.379981 4.98873 0.234526 5.13125C0.0890719 5.27378 0.00492143 5.46827 0.000209083 5.67281C-0.00450326 5.87736 0.0705998 6.07559 0.209334 6.22478L5.57801 11.8043C5.65005 11.8792 5.73625 11.9387 5.83149 11.9793C5.92674 12.02 6.02909 12.0409 6.1325 12.0409C6.23591 12.0409 6.33826 12.02 6.43351 11.9793C6.52875 11.9387 6.61495 11.8792 6.68699 11.8043L16.7738 1.32238C16.8445 1.24894 16.9002 1.16216 16.9377 1.06699C16.9752 0.971826 16.9937 0.870138 16.9922 0.767739C16.9908 0.66534 16.9693 0.564237 16.9291 0.470209C16.8889 0.37618 16.8307 0.291068 16.7579 0.219737L16.7591 0.220309Z"
				fill="#5E5E5E"
			/>
		</svg>
	);
}

export function RandomIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
		>
			<path
				d="M15.2185 12.4713L15.23 12.4814L17.8174 14.843C18.0661 15.07 18.0714 15.4587 17.8321 15.6925L17.8209 15.7032L15.4244 17.9262C15.1879 18.1456 14.8184 18.1316 14.5991 17.895C14.3833 17.6621 14.3934 17.3004 14.6192 17.0798L14.6303 17.0693L15.7915 15.992H14.9082C13.0769 15.992 11.7199 15.3766 10.6989 14.0408C10.503 13.7845 10.5519 13.4178 10.8081 13.2217C11.0643 13.0257 11.4308 13.0746 11.6267 13.3309C12.4094 14.355 13.4071 14.8142 14.8639 14.8233L14.9082 14.8234H16.0628L14.4428 13.3448C14.2083 13.1308 14.1882 12.7695 14.3948 12.5308L14.4049 12.5194C14.6188 12.2847 14.98 12.2646 15.2185 12.4713ZM15.2185 2.79479L15.23 2.80498L17.8174 5.16653C18.0661 5.39352 18.0714 5.78221 17.8321 6.01604L17.8209 6.02672L15.4244 8.24973C15.1879 8.46912 14.8184 8.45514 14.5991 8.21848C14.3833 7.98559 14.3934 7.62385 14.6192 7.4033L14.6303 7.39276L16.2137 5.92387L16.2109 5.92391H14.9082C12.4766 5.92391 10.5008 7.87649 10.4615 10.3001L10.4609 10.3737C10.4609 13.4455 7.99693 15.9416 4.93855 15.9912L4.8457 15.992H3.31836C2.99584 15.992 2.73438 15.7304 2.73438 15.4077C2.73438 15.0896 2.98842 14.8309 3.30457 14.8235L3.31836 14.8234H4.8457C7.2773 14.8234 9.25311 12.8708 9.29238 10.4472L9.29297 10.3737C9.29297 7.30174 11.757 4.80567 14.8154 4.75606L14.9082 4.7553H15.6337L14.4428 3.66834C14.2083 3.45432 14.1882 3.09299 14.3948 2.85432L14.4049 2.84287C14.6188 2.60824 14.98 2.58809 15.2185 2.79479ZM4.8457 4.7553C6.4707 4.7553 8.14834 5.61627 9.245 6.90028C9.45453 7.14559 9.42562 7.51444 9.18043 7.7241C8.93906 7.93045 8.57809 7.90567 8.36701 7.67082L8.35707 7.65949C7.4807 6.63338 6.13684 5.93793 4.88363 5.92412L4.8457 5.92393H3.31836C2.99584 5.92393 2.73438 5.66231 2.73438 5.33961C2.73438 5.02151 2.98842 4.76278 3.30457 4.75545L3.31836 4.7553H4.8457Z"
				fill="#5E5E5E"
			/>
		</svg>
	);
}

export function Level1Icon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="85"
			height="58"
			viewBox="0 0 85 58"
			fill="none"
		>
			<path
				d="M61.6064 37.5L42.2064 20L22.9064 37.5L3.50641 20L9.10641 51.6H75.4064L81.0064 20L61.6064 37.5Z"
				fill="url(#paint0_linear_911_5411)"
			/>
			<path
				d="M42.2064 20L22.9064 37.5L3.50641 20L9.10641 51.6H42.2064V20Z"
				fill="#F7C794"
			/>
			<path
				d="M32.2064 37.5004L42.2064 46.5004L52.3064 37.5004L42.2064 28.4004L32.2064 37.5004Z"
				fill="#DA2E55"
			/>
			<path
				d="M42.2064 28.4004L32.2064 37.5004L42.2064 46.5004V28.4004Z"
				fill="#FD7D9A"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_911_5411"
					x1="42.2564"
					y1="20"
					x2="42.2564"
					y2="51.6"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FFB870" />
					<stop offset="1" stopColor="#D4520C" />
				</linearGradient>
			</defs>
		</svg>
	);
}

export function Level2Icon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="85"
			height="58"
			viewBox="0 0 85 58"
			fill="none"
		>
			<path
				d="M66.5714 27.2043L58.367 19L50.1627 27.2043L41.9583 19L33.8386 27.2043L25.6342 19L17.4299 27.2043L9.22552 19L15.2308 53.1707H68.7705L74.7757 19L66.5714 27.2043Z"
				fill="url(#paint0_linear_907_4481)"
			/>
			<path
				d="M41.9583 19L33.8386 27.2043L25.6342 19L17.4299 27.2043L9.22552 19L15.2308 53.1707H41.9583V19Z"
				fill="#D7D7D7"
			/>
			<path
				d="M69.7854 47.5879H14.3004V53.1702H69.7854V47.5879Z"
				fill="#6E6E6E"
			/>
			<path
				d="M30.0324 30.9261L25.6342 35.4089L21.1514 30.9261L25.6342 26.4434L30.0324 30.9261Z"
				fill="#FD5D81"
			/>
			<path
				d="M25.6342 35.4089L21.1514 30.9261L25.6342 26.4434V35.4089Z"
				fill="#FD7D9A"
			/>
			<path
				d="M58.3692 26.5144L53.9429 30.9395L58.368 35.3658L62.7943 30.9407L58.3692 26.5144Z"
				fill="#FD5D81"
			/>
			<path
				d="M58.367 26.4434L53.9688 30.9261L58.367 35.4089V26.4434Z"
				fill="#FD7D9A"
			/>
			<path
				d="M42.0273 26.4721L37.5411 30.957L42.026 35.4432L46.5122 30.9583L42.0273 26.4721Z"
				fill="#FD5D81"
			/>
			<path
				d="M41.9583 35.4089L37.5601 30.9261L41.9583 26.4434V35.4089Z"
				fill="#FD7D9A"
			/>
			<path
				d="M42.0429 47.5879H14.3004V53.1702H42.0429V47.5879Z"
				fill="#C0C0C0"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_907_4481"
					x1="42.0006"
					y1="19"
					x2="42.0006"
					y2="53.1707"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#E1DFE0" />
					<stop offset="1" stopColor="#605860" />
				</linearGradient>
			</defs>
		</svg>
	);
}
export function Level3Icon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="85"
			height="58"
			viewBox="0 0 85 58"
			fill="none"
		>
			<path
				d="M70.8045 34.0393C65.264 24.3642 54.9273 17.9141 42.9367 17.9141C31.0288 17.9141 20.6094 24.4469 15.069 34.122H70.8045V34.0393Z"
				fill="url(#paint0_linear_907_4522)"
			/>
			<path
				d="M42.9367 17.9141C31.0288 17.9141 20.6094 24.4469 15.069 34.122H42.9367V17.9141Z"
				fill="#FD7D9A"
			/>
			<path
				d="M67.8276 22.6261C66.7526 26.7608 63.0313 29.8204 58.5659 29.8204C53.2735 29.8204 48.9734 25.5204 48.9734 20.228C48.9734 16.9202 50.6273 14.026 53.1081 12.2894L42.9368 5.17773L32.7655 12.2894C35.2463 14.026 36.9001 16.9202 36.9001 20.228C36.9001 25.5204 32.6001 29.8204 27.3077 29.8204C22.8422 29.8204 19.121 26.7608 18.046 22.6261L10.9343 27.6704L26.398 57.4401H59.4755L74.9392 27.6704L67.8276 22.6261Z"
				fill="url(#paint1_linear_907_4522)"
			/>
			<path
				d="M42.9368 5.26172L32.7655 12.3734C35.2463 14.1099 36.9001 17.0042 36.9001 20.312C36.9001 25.6044 32.6001 29.9044 27.3077 29.9044C22.8422 29.9044 19.121 26.8448 18.046 22.7101L10.9343 27.6717L26.398 57.4414H42.9368V5.26172Z"
				fill="url(#paint2_linear_907_4522)"
			/>
			<path
				d="M62.2871 52.0645H23.5864V57.5222H62.2871V52.0645Z"
				fill="#FCAE28"
			/>
			<path
				d="M42.9368 28.332L32.4347 37.8418L42.9368 47.3516L53.5216 37.8418L42.9368 28.332Z"
				fill="#FD5D81"
			/>
			<path
				opacity="0.5"
				d="M36.4867 37.8418L42.9368 31.9706V28.332L32.4347 37.8418H36.4867Z"
				fill="#FD5D81"
			/>
			<path
				opacity="0.5"
				d="M49.4696 37.8418L42.9368 43.713V47.3516L53.5216 37.8418H49.4696Z"
				fill="#FD5D81"
			/>
			<path
				d="M42.9369 31.9707L49.4697 37.842L42.9369 43.7132L36.4041 37.842L42.9369 31.9707Z"
				fill="#FD7D9A"
			/>
			<path
				d="M62.2871 52.0645H23.5864V57.5222H62.2871V52.0645Z"
				fill="url(#paint3_linear_907_4522)"
			/>
			<path
				d="M42.9367 52.0645H23.5864V57.5222H42.9367V52.0645Z"
				fill="#FDBE53"
			/>
			<path
				d="M45.5002 13.3661L42.9367 15.1027L40.4559 13.3661L42.9367 11.5469L45.5002 13.3661Z"
				fill="#FD5D81"
			/>
			<path
				d="M42.9367 15.1027L40.4559 13.3661L42.9367 11.5469V15.1027Z"
				fill="#FD7D9A"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_907_4522"
					x1="19.6171"
					y1="22.5449"
					x2="63.5357"
					y2="34.122"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FD5D81" />
					<stop offset="1" stopColor="#9E1433" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_907_4522"
					x1="42.9368"
					y1="5.17773"
					x2="42.9368"
					y2="57.4401"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FFEDC3" />
					<stop offset="1" stopColor="#F4AE0F" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_907_4522"
					x1="26.9356"
					y1="5.26172"
					x2="26.9356"
					y2="57.4414"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset="1" stopColor="#FFBD24" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_907_4522"
					x1="46.9054"
					y1="53.9664"
					x2="62.2871"
					y2="54.7933"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F3AB2F" />
					<stop offset="1" stopColor="#C7810A" />
				</linearGradient>
			</defs>
		</svg>
	);
}

export function GemIcon2(props: HTMLProps<any>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			{...props}
		>
			<path
				d="M4.49834 2.24609V6.75313H1.12158L4.49834 2.24609Z"
				fill="#FFC3DE"
			/>
			<path
				d="M13.4998 2.24609V6.75313L9.05078 2.24609H13.4998Z"
				fill="#FFC3DE"
			/>
			<path d="M16.8785 6.75313H13.5V2.24609L16.8785 6.75313Z" fill="#FFACC9" />
			<path
				d="M16.8786 6.75391L8.98604 15.7539L13.5001 6.75391H16.8786ZM8.98604 15.7539L1.12158 6.75391H4.49834L8.98604 15.7539Z"
				fill="#FD76A4"
			/>
			<path
				d="M13.4998 6.75391L8.98574 15.7539L4.49805 6.75391H13.4998Z"
				fill="#FFC3DE"
			/>
			<path
				d="M9.05078 2.24609L4.49805 6.75313V2.24609H9.05078Z"
				fill="#FFACC9"
			/>
			<path
				d="M13.4998 6.75313H4.49805L9.05078 2.24609L13.4998 6.75313Z"
				fill="white"
			/>
		</svg>
	);
}

export function FilterIcon(props: HTMLProps<any>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			{...props}
		>
			<path
				d="M5.83345 11.6667C5.8334 11.7751 5.86355 11.8813 5.92053 11.9736C5.97751 12.0658 6.05906 12.1403 6.15603 12.1887L7.3227 12.7721C7.41165 12.8165 7.5105 12.8375 7.60984 12.833C7.70918 12.8285 7.80573 12.7987 7.8903 12.7464C7.97487 12.6941 8.04467 12.621 8.09306 12.5341C8.14145 12.4472 8.16683 12.3494 8.16678 12.25V8.16667C8.16691 7.87756 8.27439 7.59879 8.46837 7.38442L12.6818 2.72417C12.7573 2.64049 12.807 2.53673 12.8248 2.42543C12.8426 2.31413 12.8277 2.20006 12.7821 2.09701C12.7364 1.99396 12.6619 1.90635 12.5675 1.84476C12.4731 1.78318 12.3628 1.75027 12.2501 1.75H1.75012C1.6373 1.75004 1.52692 1.78279 1.43234 1.84429C1.33777 1.90578 1.26305 1.99338 1.21724 2.09648C1.17144 2.19957 1.15651 2.31374 1.17426 2.42514C1.19202 2.53655 1.2417 2.64042 1.31728 2.72417L5.53186 7.38442C5.72584 7.59879 5.83332 7.87756 5.83345 8.16667V11.6667Z"
				stroke="#8A8A8A"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function CheckIcon2(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="8"
			height="7"
			viewBox="0 0 8 7"
			fill="none"
		>
			<path d="M1 3L3 5L7 1" stroke="white" strokeWidth="1.5" />
		</svg>
	);
}

export function DeleteIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M2 4H14"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.6663 4V13.3333C12.6663 14 11.9997 14.6667 11.333 14.6667H4.66634C3.99967 14.6667 3.33301 14 3.33301 13.3333V4"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.33301 4.00065V2.66732C5.33301 2.00065 5.99967 1.33398 6.66634 1.33398H9.33301C9.99967 1.33398 10.6663 2.00065 10.6663 2.66732V4.00065"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.66699 7.33398V11.334"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.33301 7.33398V11.334"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function EditIcon2(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M8 13.334H14"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.9176 2.41449C11.183 2.1491 11.543 2 11.9183 2C12.2936 2 12.6536 2.1491 12.919 2.41449C13.1844 2.67988 13.3335 3.03983 13.3335 3.41516C13.3335 3.79048 13.1844 4.15043 12.919 4.41582L4.91231 12.4232C4.75371 12.5818 4.55766 12.6978 4.34231 12.7605L2.42764 13.3192C2.37028 13.3359 2.30947 13.3369 2.25158 13.3221C2.1937 13.3072 2.14086 13.2771 2.09861 13.2349C2.05635 13.1926 2.02624 13.1398 2.01141 13.0819C1.99658 13.024 1.99758 12.9632 2.01431 12.9058L2.57298 10.9912C2.63579 10.776 2.75181 10.5802 2.91031 10.4218L10.9176 2.41449Z"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10 3.33398L12 5.33398"
				stroke="#5E5E5E"
				strokeWidth="0.666667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function PublishIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8 13.9993V4.66602"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.667 7.99935L12.0003 9.33268L14.667 6.66602"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.6663 4V2.66667C14.6663 2.48986 14.5961 2.32029 14.4711 2.19526C14.3461 2.07024 14.1765 2 13.9997 2H10.6663C9.9591 2 9.28082 2.28095 8.78072 2.78105C8.28063 3.28115 7.99967 3.95942 7.99967 4.66667C7.99967 3.95942 7.71872 3.28115 7.21863 2.78105C6.71853 2.28095 6.04025 2 5.33301 2H1.99967C1.82286 2 1.65329 2.07024 1.52827 2.19526C1.40325 2.32029 1.33301 2.48986 1.33301 2.66667V11.3333C1.33301 11.5101 1.40325 11.6797 1.52827 11.8047C1.65329 11.9298 1.82286 12 1.99967 12H5.99967C6.53011 12 7.03882 12.2107 7.41389 12.5858C7.78896 12.9609 7.99967 13.4696 7.99967 14C7.99967 13.4696 8.21039 12.9609 8.58546 12.5858C8.96053 12.2107 9.46924 12 9.99967 12H13.9997C14.1765 12 14.3461 11.9298 14.4711 11.8047C14.5961 11.6797 14.6663 11.5101 14.6663 11.3333V10.4667"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function AvailableIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8 8.66602V4.66602"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.0003 1.33398H12.667C12.8438 1.33398 13.0134 1.40422 13.1384 1.52925C13.2634 1.65427 13.3337 1.82384 13.3337 2.00065V14.0007C13.3337 14.1775 13.2634 14.347 13.1384 14.4721C13.0134 14.5971 12.8438 14.6673 12.667 14.6673H4.33366C3.89163 14.6673 3.46771 14.4917 3.15515 14.1792C2.84259 13.8666 2.66699 13.4427 2.66699 13.0007C2.66699 12.5586 2.84259 12.1347 3.15515 11.8221C3.46771 11.5096 3.89163 11.334 4.33366 11.334H13.3337"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.66699 13.0007V3.00065C2.66699 2.55862 2.84259 2.1347 3.15515 1.82214C3.46771 1.50958 3.89163 1.33398 4.33366 1.33398"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 6.66602L8 4.66602L10 6.66602"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 3.33398L8 1.33398L10 3.33398"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function UnAvailableIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M8 8.66602V4.66602"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.66699 13.0007V3.00065C2.66699 2.55862 2.84259 2.1347 3.15515 1.82214C3.46771 1.50958 3.89163 1.33398 4.33366 1.33398H12.667C12.8438 1.33398 13.0134 1.40422 13.1384 1.52925C13.2634 1.65427 13.3337 1.82384 13.3337 2.00065V14.0007C13.3337 14.1775 13.2634 14.347 13.1384 14.4721C13.0134 14.5971 12.8438 14.6673 12.667 14.6673H4.33366C3.89163 14.6673 3.46771 14.4917 3.15515 14.1792C2.84259 13.8666 2.66699 13.4427 2.66699 13.0007ZM2.66699 13.0007C2.66699 12.5586 2.84259 12.1347 3.15515 11.8221C3.46771 11.5096 3.89163 11.334 4.33366 11.334H13.3337"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 6.66602L8 8.66602L10 6.66602"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function XIcon(props: HTMLProps<any>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="28"
			height="29"
			viewBox="0 0 28 29"
			fill="none"
			{...props}
		>
			<path
				d="M20.708 4.02734H24.2615L16.4981 12.9004L25.6312 24.9746H18.4801L12.8791 17.6517L6.4703 24.9746H2.91465L11.2184 15.4839L2.45703 4.02734H9.78966L14.8525 10.7208L20.708 4.02734ZM19.4608 22.8477H21.4299L8.71971 6.04259H6.60671L19.4608 22.8477Z"
				fill="white"
			/>
		</svg>
	);
}

export function DiscordIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			stroke="currentColor"
			fill="currentColor"
			strokeWidth="0"
			viewBox="0 0 640 512"
			height="200px"
			width="200px"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z" />
		</svg>
	);
}

export function TelegramIcon(props: HTMLProps<any>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="29"
			height="29"
			viewBox="0 0 29 29"
			fill="none"
			{...props}
		>
			<path
				d="M10.3023 24.207L10.6761 18.7589L20.9294 9.84619C21.3833 9.44692 20.8359 9.25372 20.2351 9.60147L7.5788 17.3164L2.10507 15.642C0.930216 15.32 0.916865 14.5344 2.37208 13.9677L23.6929 6.03382C24.6675 5.60879 25.6021 6.26566 25.2283 7.70817L21.5969 24.207C21.3432 25.379 20.609 25.6623 19.5943 25.1214L14.0672 21.1802L11.4104 23.666C11.1033 23.9622 10.8497 24.207 10.3023 24.207Z"
				fill="#21A5F8"
			/>
		</svg>
	);
}

export function NoDataIcon(props: HTMLProps<any>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="120"
			height="120"
			viewBox="0 0 120 120"
			fill="none"
			{...props}
		>
			<path
				d="M60.0427 70.7289L21.3594 60.5663L60.3761 52.0416C60.3956 52.0374 60.4156 52.0374 60.4351 52.0416L99.4518 60.5663L60.1123 70.729C60.0895 70.7349 60.0655 70.7349 60.0427 70.7289Z"
				fill="#EE3771"
			/>
			<path
				d="M22.1357 61.123L60.1299 70.9277C60.2821 70.967 60.3885 71.1045 60.3887 71.2617V106.925C60.3887 107.122 60.226 107.273 60.0391 107.271L59.957 107.259L21.9629 97.4541C21.8107 97.4147 21.7042 97.2773 21.7041 97.1201V61.457C21.7041 61.2596 21.8675 61.109 22.0547 61.1123L22.1357 61.123Z"
				fill="white"
				stroke="black"
				strokeWidth="0.69"
			/>
			<path
				d="M60.0498 70.9072L41.2734 89.0479L2.68164 79.0889L21.459 60.9482L60.0498 70.9072Z"
				fill="white"
				stroke="black"
				strokeWidth="0.69"
			/>
			<path
				d="M98.6748 61.123L60.6807 70.9277C60.5284 70.967 60.422 71.1045 60.4219 71.2617V106.914C60.4219 107.111 60.5846 107.263 60.7715 107.26L60.8535 107.248L98.8477 97.4434C98.9999 97.4039 99.1064 97.2666 99.1064 97.1094V61.457C99.1064 61.2596 98.943 61.109 98.7559 61.1123L98.6748 61.123Z"
				fill="#FFEEF9"
				stroke="black"
				strokeWidth="0.69"
			/>
			<path
				d="M60.7588 70.9072L79.5352 89.0479L118.127 79.0889L99.3496 60.9482L60.7588 70.9072Z"
				fill="#FFEEF9"
				stroke="black"
				strokeWidth="0.69"
			/>
			<rect
				x="14.5195"
				y="31"
				width="0.413784"
				height="13.0342"
				fill="#2DE82A"
			/>
			<rect
				x="21.2441"
				y="36.998"
				width="0.413784"
				height="13.0342"
				transform="rotate(90 21.2441 36.998)"
				fill="#2DE82A"
			/>
			<path
				d="M14.5523 35.0456C14.6061 34.8441 14.892 34.8441 14.9458 35.0456C15.2043 36.014 15.9607 36.7703 16.9291 37.0289C17.1306 37.0826 17.1306 37.3686 16.9291 37.4224C15.9607 37.6809 15.2043 38.4373 14.9458 39.4056C14.892 39.6071 14.6061 39.6071 14.5523 39.4056C14.2938 38.4373 13.5374 37.6809 12.569 37.4224C12.3675 37.3686 12.3675 37.0826 12.569 37.0289C13.5374 36.7703 14.2938 36.014 14.5523 35.0456Z"
				fill="#2DE82A"
			/>
		</svg>
	);
}

export function BitcoinIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="33"
			height="33"
			viewBox="0 0 33 33"
			fill="none"
		>
			<g clipPath="url(#clip0_152_5655)">
				<path
					d="M0 16.4766C-3.2288e-08 18.6434 0.426785 20.789 1.25599 22.7908C2.08519 24.7927 3.30057 26.6117 4.83274 28.1438C6.3649 29.676 8.18385 30.8914 10.1857 31.7206C12.1876 32.5498 14.3332 32.9766 16.5 32.9766C18.6668 32.9766 20.8124 32.5498 22.8143 31.7206C24.8161 30.8914 26.6351 29.676 28.1673 28.1438C29.6994 26.6117 30.9148 24.7927 31.744 22.7908C32.5732 20.789 33 18.6434 33 16.4766C33 14.3098 32.5732 12.1642 31.744 10.1623C30.9148 8.16041 29.6994 6.34147 28.1673 4.8093C26.6351 3.27713 24.8161 2.06175 22.8143 1.23255C20.8124 0.403348 18.6668 -0.0234375 16.5 -0.0234375C14.3332 -0.0234375 12.1876 0.403348 10.1857 1.23255C8.18385 2.06175 6.3649 3.27713 4.83274 4.8093C3.30057 6.34147 2.08519 8.16041 1.25599 10.1623C0.426785 12.1642 -3.2288e-08 14.3098 0 16.4766Z"
					fill="#808080"
				/>
				<path
					d="M20.998 16.546L20.8122 16.4962C22.3999 16.8933 24.0333 15.9501 24.4603 14.3562C24.5643 13.9725 24.5915 13.572 24.5401 13.1777C24.4888 12.7835 24.3601 12.4032 24.1613 12.0589C23.9625 11.7146 23.6976 11.413 23.3819 11.1714C23.0661 10.9299 22.7057 10.7531 22.3214 10.6513L20.98 10.2918L21.7771 7.31668L19.8646 6.80416L19.0674 9.77932L17.534 9.36858L18.3326 6.38825L16.4171 5.875L15.6185 8.85532L12.1079 7.91473L11.5493 9.99982L13.9932 10.6547L11.438 20.1907L8.99415 19.5359L8.43555 21.621L11.9461 22.5616L11.1202 25.644L13.0356 26.1573L13.8616 23.0748L15.395 23.4856L14.5695 26.5669L16.482 27.0794L17.3076 23.9981L18.8883 24.4217C21.0662 25.0054 23.3062 23.7123 23.8899 21.534C24.4735 19.3556 23.176 17.1297 20.998 16.546ZM17.145 11.4282L18.5262 11.7984L19.4424 12.044C19.8141 12.1435 20.1179 12.3389 20.3568 12.6166C20.7761 13.0705 20.9553 13.7305 20.7842 14.368C20.6135 15.0055 20.1282 15.4878 19.5383 15.671C19.1928 15.792 18.8322 15.8093 18.4602 15.7097L17.5439 15.4642L16.1627 15.094L17.145 11.4282ZM17.9764 21.5015C17.9329 21.5041 17.9064 21.4971 17.8665 21.4864L16.0602 21.0023L14.679 20.6321L15.6613 16.9663L17.0425 17.3365L18.8488 17.8206C18.8886 17.8313 18.9152 17.8383 18.9517 17.8623C19.8971 18.1584 20.4505 19.1749 20.1906 20.1446C19.9306 21.1144 18.9432 21.7179 17.9764 21.5015Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_152_5655">
					<rect width="33" height="33" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function USDTIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="33"
			height="34"
			viewBox="0 0 33 34"
			fill="none"
		>
			<g clipPath="url(#clip0_152_5649)">
				<path
					d="M16.5605 0.576172C25.6281 0.576204 32.9785 7.92676 32.9785 16.9941C32.9785 26.0617 25.6281 33.4121 16.5605 33.4121C7.49326 33.4121 0.142578 26.0618 0.142578 16.9941C0.142637 7.92674 7.4933 0.576172 16.5605 0.576172ZM8.71875 8.85547V12.6084H14.6152V15.0938C10.0539 15.2936 6.61155 16.1941 6.61133 17.2754C6.61133 18.3568 10.0548 19.2584 14.6172 19.458V27.377H18.3691V19.4609C22.9666 19.2675 26.4463 18.3624 26.4463 17.2754C26.4461 16.1883 22.9663 15.2851 18.3682 15.0918V12.6084H24.2646V8.85547H8.71875ZM18.3682 15.3018C22.3631 15.467 25.3613 16.1592 25.3613 16.9883C25.3606 17.9406 21.4056 18.7119 16.5283 18.7119C11.6512 18.7119 7.69702 17.9405 7.69629 16.9883C7.69629 16.1643 10.6572 15.4754 14.6152 15.3047V18.125H18.3682V15.3018Z"
					fill="#606060"
				/>
			</g>
			<defs>
				<clipPath id="clip0_152_5649">
					<rect
						width="33"
						height="33"
						fill="white"
						transform="translate(0.0078125 0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

export function SaveIcon(props: HTMLProps<any>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			{...props}
		>
			<path
				d="M9.63333 1C9.98503 1.00501 10.3205 1.14878 10.5667 1.4L13.1 3.93333C13.3512 4.17951 13.495 4.51497 13.5 4.86667V11.6667C13.5 12.0203 13.3595 12.3594 13.1095 12.6095C12.8594 12.8595 12.5203 13 12.1667 13H2.83333C2.47971 13 2.14057 12.8595 1.89052 12.6095C1.64048 12.3594 1.5 12.0203 1.5 11.6667V2.33333C1.5 1.97971 1.64048 1.64057 1.89052 1.39052C2.14057 1.14048 2.47971 1 2.83333 1H9.63333Z"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.8337 12.9993V8.33268C10.8337 8.15587 10.7634 7.9863 10.6384 7.86128C10.5134 7.73625 10.3438 7.66602 10.167 7.66602H4.83366C4.65685 7.66602 4.48728 7.73625 4.36225 7.86128C4.23723 7.9863 4.16699 8.15587 4.16699 8.33268V12.9993"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4.16699 1V3.66667C4.16699 3.84348 4.23723 4.01305 4.36225 4.13807C4.48728 4.2631 4.65685 4.33333 4.83366 4.33333H9.50033"
				stroke="#353535"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function CopyIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
		>
			<g clipPath="url(#clip0_71_594)">
				<path
					d="M12.6667 4.66602H6.83335C6.18902 4.66602 5.66669 5.18835 5.66669 5.83268V11.666C5.66669 12.3103 6.18902 12.8327 6.83335 12.8327H12.6667C13.311 12.8327 13.8334 12.3103 13.8334 11.666V5.83268C13.8334 5.18835 13.311 4.66602 12.6667 4.66602Z"
					stroke="white"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M3.33335 9.33268C2.69169 9.33268 2.16669 8.80768 2.16669 8.16602V2.33268C2.16669 1.69102 2.69169 1.16602 3.33335 1.16602H9.16669C9.80835 1.16602 10.3334 1.69102 10.3334 2.33268"
					stroke="white"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_71_594">
					<rect width="14" height="14" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export function ArrowLeftIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
		>
			<path
				d="M13 17L5 9L13 1"
				stroke="#353535"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function ChevronDownIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="none"
		>
			<path
				d="M3 4.5L6 7.5L9 4.5"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function ChevronLeftIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M11.5564 15.1109L4.44531 7.99978L11.5564 0.888672"
				stroke="currentColor"
				strokeWidth="1.33333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function CreateIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.6667 10.6667H14.6667"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.6667 8.66675V12.6667"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 6.66668V5.33335C13.9998 5.09953 13.938 4.86989 13.821 4.66746C13.704 4.46503 13.5358 4.29692 13.3333 4.18002L8.66667 1.51335C8.46397 1.39633 8.23405 1.33472 8 1.33472C7.76595 1.33472 7.53603 1.39633 7.33333 1.51335L2.66667 4.18002C2.46418 4.29692 2.29599 4.46503 2.17897 4.66746C2.06196 4.86989 2.00024 5.09953 2 5.33335V10.6667C2.00024 10.9005 2.06196 11.1301 2.17897 11.3326C2.29599 11.535 2.46418 11.7031 2.66667 11.82L7.33333 14.4867C7.53603 14.6037 7.76595 14.6653 8 14.6653C8.23405 14.6653 8.46397 14.6037 8.66667 14.4867L10 13.7267"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5 2.84668L11 6.28001"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.19336 4.66675L8.00003 8.00008L13.8067 4.66675"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 14.6667V8"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function SearchIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			width="22"
			height="23"
			viewBox="0 0 22 23"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.0834 2.7915C14.3866 2.7915 17.875 6.27988 17.875 10.5832C17.875 12.4325 17.2306 14.1316 16.1544 15.4676C16.2433 15.4847 16.3249 15.5282 16.3886 15.5923L19.3055 18.5091C19.3914 18.5951 19.4397 18.7116 19.4397 18.8332C19.4397 18.9547 19.3914 19.0713 19.3055 19.1572L18.6574 19.8053C18.5714 19.8912 18.4549 19.9395 18.3334 19.9395C18.2118 19.9395 18.0953 19.8912 18.0093 19.8053L15.0925 16.8885C15.0283 16.8246 14.9846 16.7431 14.9669 16.6543C13.5842 17.7703 11.8602 18.3777 10.0834 18.3748C5.78006 18.3748 2.29169 14.8865 2.29169 10.5832C2.29169 6.27988 5.78006 2.7915 10.0834 2.7915ZM10.0834 4.62484C6.79252 4.62484 4.12502 7.29234 4.12502 10.5832C4.12502 13.874 6.79252 16.5415 10.0834 16.5415C13.3742 16.5415 16.0417 13.874 16.0417 10.5832C16.0417 7.29234 13.3742 4.62484 10.0834 4.62484Z"
				fill="#8A8A8A"
			/>
		</svg>
	);
}

export function RecommendIcon(props: HTMLProps<any>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			{...props}
		>
			<g clipPath="url(#clip0_146_4801)">
				<path
					d="M4.66666 6.66663V14.6666"
					stroke="#5E5E5E"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10 3.92004L9.33334 6.66671H13.22C13.427 6.66671 13.6312 6.7149 13.8163 6.80747C14.0014 6.90004 14.1625 7.03445 14.2867 7.20004C14.4109 7.36564 14.4948 7.55787 14.5318 7.76153C14.5689 7.96518 14.558 8.17466 14.5 8.37337L12.9467 13.7067C12.8659 13.9837 12.6975 14.2269 12.4667 14.4C12.2359 14.5731 11.9552 14.6667 11.6667 14.6667H2.66668C2.31305 14.6667 1.97392 14.5262 1.72387 14.2762C1.47382 14.0261 1.33334 13.687 1.33334 13.3334V8.00004C1.33334 7.64642 1.47382 7.30728 1.72387 7.05723C1.97392 6.80718 2.31305 6.66671 2.66668 6.66671H4.50668C4.75473 6.66658 4.99783 6.59725 5.20865 6.46652C5.41946 6.33579 5.58963 6.14885 5.70001 5.92671L8.00001 1.33337C8.3144 1.33727 8.62384 1.41215 8.90521 1.55244C9.18659 1.69272 9.43263 1.89478 9.62495 2.14351C9.81726 2.39224 9.95089 2.68121 10.0158 2.98884C10.0808 3.29647 10.0754 3.6148 10 3.92004Z"
					stroke="#5E5E5E"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_146_4801">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
export function HotIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M5.66668 9.66667C6.1087 9.66667 6.53263 9.49107 6.84519 9.17851C7.15775 8.86595 7.33334 8.44203 7.33334 8C7.33334 7.08 7.00001 6.66667 6.66668 6C5.95201 4.57133 6.51734 3.29733 8.00001 2C8.33334 3.66667 9.33334 5.26667 10.6667 6.33333C12 7.4 12.6667 8.66667 12.6667 10C12.6667 10.6128 12.546 11.2197 12.3114 11.7859C12.0769 12.352 11.7332 12.8665 11.2998 13.2998C10.8665 13.7332 10.3521 14.0769 9.78587 14.3114C9.21968 14.546 8.61285 14.6667 8.00001 14.6667C7.38717 14.6667 6.78034 14.546 6.21415 14.3114C5.64797 14.0769 5.13352 13.7332 4.70018 13.2998C4.26684 12.8665 3.92309 12.352 3.68857 11.7859C3.45405 11.2197 3.33334 10.6128 3.33334 10C3.33334 9.23133 3.62201 8.47067 4.00001 8C4.00001 8.44203 4.1756 8.86595 4.48817 9.17851C4.80073 9.49107 5.22465 9.66667 5.66668 9.66667Z"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
export function RateIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M7.68332 1.52997C7.71254 1.47094 7.75767 1.42126 7.81362 1.38652C7.86958 1.35178 7.93413 1.33337 7.99999 1.33337C8.06585 1.33337 8.1304 1.35178 8.18635 1.38652C8.24231 1.42126 8.28744 1.47094 8.31666 1.52997L9.85666 4.6493C9.95811 4.85461 10.1079 5.03224 10.2931 5.16694C10.4783 5.30164 10.6934 5.38938 10.92 5.42264L14.364 5.92664C14.4292 5.93609 14.4906 5.96362 14.541 6.0061C14.5914 6.04859 14.6289 6.10434 14.6493 6.16704C14.6697 6.22975 14.6722 6.29691 14.6564 6.36093C14.6406 6.42495 14.6072 6.48327 14.56 6.5293L12.0693 8.95464C11.9051 9.1147 11.7822 9.31229 11.7112 9.53039C11.6403 9.74849 11.6234 9.98056 11.662 10.2066L12.25 13.6333C12.2615 13.6985 12.2545 13.7657 12.2297 13.8271C12.2048 13.8885 12.1633 13.9417 12.1097 13.9806C12.0561 14.0196 11.9926 14.0426 11.9266 14.0472C11.8605 14.0518 11.7945 14.0378 11.736 14.0066L8.65732 12.388C8.45447 12.2815 8.22878 12.2258 7.99966 12.2258C7.77054 12.2258 7.54484 12.2815 7.34199 12.388L4.26399 14.0066C4.20554 14.0376 4.13959 14.0515 4.07362 14.0468C4.00766 14.0421 3.94433 14.019 3.89085 13.9801C3.83737 13.9412 3.79588 13.8881 3.77109 13.8268C3.74631 13.7655 3.73923 13.6984 3.75066 13.6333L4.33799 10.2073C4.37679 9.98112 4.35998 9.7489 4.28901 9.53067C4.21805 9.31243 4.09506 9.11474 3.93066 8.95464L1.43999 6.52997C1.39239 6.48399 1.35865 6.42557 1.34263 6.36135C1.32661 6.29714 1.32895 6.22972 1.34938 6.16676C1.3698 6.10381 1.4075 6.04786 1.45817 6.00529C1.50885 5.96272 1.57046 5.93524 1.63599 5.92597L5.07932 5.42264C5.30616 5.38964 5.52158 5.30201 5.70705 5.16729C5.89251 5.03258 6.04246 4.85482 6.14399 4.6493L7.68332 1.52997Z"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
export function TimeIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M2 8C2 9.18669 2.35189 10.3467 3.01118 11.3334C3.67047 12.3201 4.60754 13.0892 5.7039 13.5433C6.80026 13.9974 8.00666 14.1162 9.17054 13.8847C10.3344 13.6532 11.4035 13.0818 12.2426 12.2426C13.0818 11.4035 13.6532 10.3344 13.8847 9.17054C14.1162 8.00666 13.9974 6.80026 13.5433 5.7039C13.0892 4.60754 12.3201 3.67047 11.3334 3.01118C10.3467 2.35189 9.18669 2 8 2C6.32263 2.00631 4.71265 2.66082 3.50667 3.82667L2 5.33333"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 2V5.33333H5.33333"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 4.66663V7.99996L10.6667 9.33329"
				stroke="#5E5E5E"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function Time2Icon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="none"
		>
			<path
				d="M6 0.857143C6.69466 0.857143 7.36808 0.993 8.00158 1.26094C8.61388 1.51992 9.16397 1.89086 9.63655 2.36345C10.1091 2.83603 10.4801 3.38612 10.7391 3.99842C11.007 4.63191 11.1429 5.30534 11.1429 6C11.1429 6.69466 11.007 7.36808 10.7391 8.00158C10.4801 8.61388 10.1091 9.16397 9.63655 9.63655C9.16397 10.1091 8.61388 10.4801 8.00158 10.7391C7.36809 11.007 6.69466 11.1429 6 11.1429C5.30534 11.1429 4.63192 11.007 3.99842 10.7391C3.38612 10.4801 2.83603 10.1091 2.36345 9.63655C1.89086 9.16397 1.51993 8.61388 1.26094 8.00158C0.993 7.36809 0.857143 6.69466 0.857143 6C0.857143 5.30534 0.993 4.63192 1.26094 3.99842C1.51992 3.38612 1.89086 2.83603 2.36345 2.36345C2.83603 1.89086 3.38612 1.51993 3.99842 1.26094C4.63192 0.993 5.30534 0.857143 6 0.857143ZM6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0Z"
				className="fill-t4"
			/>
			<path
				d="M8.56504 6.42857H6C5.76331 6.42857 5.57143 6.23671 5.57143 6V2.15987C5.57143 1.92317 5.76331 1.73129 6 1.73129C6.23669 1.73129 6.42857 1.92317 6.42857 2.15987V5.57143H8.56503C8.80172 5.57143 8.9936 5.76331 8.9936 6C8.9936 6.23669 8.80173 6.42857 8.56504 6.42857Z"
				className="fill-t4"
			/>
		</svg>
	);
}

export function FireIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="10"
			height="13"
			viewBox="0 0 10 13"
			fill="none"
		>
			<path
				d="M8.80986 2.82455C7.12318 3.33267 6.81438 4.77258 6.92311 5.68719C5.72 4.19358 5.76932 2.47538 5.76932 0C1.91091 1.5366 2.80734 5.96704 2.69245 7.3124C1.7219 6.47346 1.53856 4.46903 1.53856 4.46903C0.51393 5.02555 0 6.51267 0 7.71879C0 10.6356 2.23865 13 5 13C7.76129 13 10 10.6356 10 7.71879C10 5.98533 8.79505 5.18547 8.80957 2.82455H8.80986Z"
				fill="url(#paint0_linear_89_1904)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_89_1904"
					x1="5"
					y1="0"
					x2="5"
					y2="13"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#EC3232" />
					<stop offset="1" stopColor="#FBCCCC" />
				</linearGradient>
			</defs>
		</svg>
	);
}

export function MenuIcon(props: HTMLProps<any>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="28"
			height="18"
			viewBox="0 0 28 18"
			fill="none"
			{...props}
		>
			<path
				d="M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2C28 3.10457 27.1046 4 26 4H2C0.895431 4 0 3.10457 0 2Z"
				fill="currentColor"
			/>
			<path
				d="M0 9C0 7.89543 0.895431 7 2 7H26C27.1046 7 28 7.89543 28 9C28 10.1046 27.1046 11 26 11H2C0.895431 11 0 10.1046 0 9Z"
				fill="currentColor"
			/>
			<path
				d="M0 16C0 14.8954 0.895431 14 2 14H26C27.1046 14 28 14.8954 28 16C28 17.1046 27.1046 18 26 18H2C0.895431 18 0 17.1046 0 16Z"
				fill="currentColor"
			/>
		</svg>
	);
}

export function MemberPackActiveIcon(props: HTMLProps<any>) {
	return (
		<svg
			width="34"
			height="34"
			viewBox="0 0 34 34"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M0 0H14C25.0457 0 34 8.95431 34 20V34H20C8.9543 34 0 25.0457 0 14V0Z"
				fill="#EC3232"
				fillOpacity="0.54"
			/>
			<path
				d="M27.6193 12.211L16.153 23.8157L15.8173 24.132L15.4815 23.8157L8.38086 16.6292L10.696 14.2857L15.8167 19.4689L25.3041 9.86719L27.6193 12.211Z"
				fill="white"
			/>
		</svg>
	);
}

export function MemberPackLeftActiveIcon(props: HTMLProps<any>) {
	return (
		<svg
			width="34"
			height="34"
			viewBox="0 0 34 34"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g opacity="0.5">
				<path
					d="M34 0H20C8.95431 0 0 8.95431 0 20V34H14C25.0457 34 34 25.0457 34 14V0Z"
					fill="#36BA45"
				/>
			</g>
			<path
				d="M25.6193 12.211L14.153 23.8157L13.8173 24.132L13.4815 23.8157L6.38086 16.6292L8.69603 14.2857L13.8167 19.4689L23.3041 9.86719L25.6193 12.211Z"
				fill="white"
			/>
		</svg>
	);
}
export function RefreshIcon(props: HTMLProps<any>) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="22"
			height="22"
			viewBox="0 0 22 22"
			fill="none"
		>
			<path
				d="M11 0.488281C5.19453 0.488281 0.488281 5.19453 0.488281 11C0.488281 16.8055 5.19453 21.5117 11 21.5117C16.8055 21.5117 21.5117 16.8055 21.5117 11C21.5117 5.19453 16.8055 0.488281 11 0.488281ZM3.64062 10.9438H5.69375C5.69375 7.74922 8.09141 5.23906 11.1711 5.35391C12.1977 5.35391 13.1117 5.69609 14.0234 6.15313L12.9969 7.17969C12.425 6.95 11.7406 6.72266 11.0563 6.72266C8.88828 6.72266 7.0625 8.54844 7.0625 10.9438H9.11563L6.37812 13.7961L3.64062 10.9438ZM16.3039 10.9414C16.3039 14.0211 13.9086 16.6461 10.9414 16.6461C9.91484 16.6461 9.00078 16.1914 8.08906 15.7344L9.11563 14.7078C9.6875 14.9375 10.3719 15.1648 11.0563 15.1648C13.2242 15.1648 15.05 13.3391 15.05 10.9438H12.882L15.6219 8.09141L18.3594 10.9414H16.3039Z"
				fill="currentColor"
			/>
		</svg>
	);
}
